<template>
	<div class="bottom-item-editor">
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="!!categoryId" @toggling-popup="handleTogglingPopup">
			<div class="bottom-item-editor-content" v-if="!!categoryId">
				<ModalHeader :title="getString('add_x', [currentCategory.name])" />
				<AppList :items="items">
					<template #btn-slot="{item}">
						<div class="row centered space-between">
							<p class="list-item-title">{{ item.title }}</p>
							<AppButton outline small :text="getString('add')" @click="pickedItem(item)" />
						</div>
					</template>
				</AppList>
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";
import {useCounterStore, useUserStore, useMenuStore} from "@/console-new/stores";
import AppList from "@/shared/components/AppList.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppButton from "@/shared/components/AppButton.vue";

export default {
	setup() {
		let languageStore = useLanguageStore();
		const counterStore = useCounterStore();
		const userStore = useUserStore();
		const currencyStore = useCurrencyStore();
		const menuStore = useMenuStore();
		return {getString: languageStore.getString, counterStore, menuStore, currencyStore, userStore};
	},
	name: "BottomShortcutsSelector",
	emits: ["closing-popup", "picked-item"],
	components: {AppButton, ModalHeader, AppList, AppBottomSheet, AppTextInput},
	mixins: [WindowWidth],
	props: {
		categoryId: Number,
	},
	data() {
		return {
			priceEdit: false,
		}
	},
	computed: {
		currentCategory() {
			return this.menuStore.categories?.[this.categoryId] || {};
		},
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		items() {
			if(!this.currentCategory?.items) {
				return [];
			}
			let items = [];
			for(let itemId in this.currentCategory.items) {
				if(!this.currentCategory.items[itemId].deleted_item) {
					items.push({
						...this.currentCategory.items[itemId],
						title: this.currentCategory.items[itemId].name,
						customSlot: 'btn-slot',
					});
				}

			}
			return items;
		},
	},
	methods: {
		pickedItem(item) {
			this.$emit("picked-item", this.menuStore.items[item.menu_item_id]);
		},
		handleTogglingPopup(open) {
			if(!open) {
				this.$emit("closing-popup");
			}
		}
	},
}
</script>

<style scoped lang="scss">
.list-item-title {
	overflow-wrap: break-word;
	max-width: calc(100% - 100px);
}
</style>